<template>
    <div class="couponList">
        <div class="search_box">
            <div class="left">
                <el-button type="primary" @click="addCoupon">新增优惠券</el-button>
            </div>
            <div class="right">
                <el-input v-model="name" placeholder="输入优惠券名称"></el-input>
                <el-button @click="search">搜索</el-button>
            </div>
        </div>
        <el-table :data="list" style="width: 100%">
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column prop="voucherdistypename" label="类型" class-name="center"></el-table-column>
            <el-table-column label="优惠内容" class-name="center">
                <template slot-scope="scope">
                    <div>
                        <p>{{scope.row.prefercontent}}</p>
                        <p>{{scope.row.usescopetypename}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="已领数量/总量" class-name="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.currentgetcount}}/{{scope.row.totalcount === 0 ? '不限制' : scope.row.totalcount}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="currentusecount" label="已使用" class-name="center"></el-table-column>
            <el-table-column label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="btn">
                        <span class="handle" v-if="scope.row.status === 1" @click="editCoupon(scope.row)">编辑</span>
                        <span class="line" v-if="scope.row.status === 1">&nbsp;|&nbsp;</span>
                        <span class="handle" v-if="scope.row.status === 1" @click="stopCoupon(scope.row)">停止</span>
                        <span class="line" v-if="scope.row.status === 1">&nbsp;|&nbsp;</span>
                        <span class="handle" v-if="scope.row.status !== 1" @click="checkCoupon(scope.row)">查看</span>
                        <span class="line" v-if="scope.row.status !== 1">&nbsp;|&nbsp;</span>
                        <span class="handle" @click="copyCoupon(scope.row)">复制</span>
                        <span class="line">&nbsp;|&nbsp;</span>
                        <span class="handle" @click="statisticsCoupon(scope.row)">统计</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="getcouponVoucherListV2" ref="page"></page>
    </div>
</template>
<script>
import {getcouponVoucherListV2, cancelCouponVoucher} from 'api/marketingCenterApi'
import {mapActions, mapGetters} from 'vuex'
import Page from 'base/page/page'
export default {
    name: 'couponList',
    data() {
        return {
            list: [],
            name: '',
            total: 0
        }
    },
    created() {
        this.getcouponVoucherListV2()
    },
    methods: {
        search() {
            this.setPage({page: 1, pageSize: 10})
            this.getcouponVoucherListV2()
        },
        // 新增优惠券
        addCoupon() {
            this.$router.push({
                name: 'CouponEdit'
            })
        },
        getcouponVoucherListV2() {
            const params = {
                name: this.name,
                page: this.page.page,
                pageSize: this.page.pageSize
            }
            this.setLoading(true)
            console.log(params)
            getcouponVoucherListV2({
                data: params,
                success: res => {
                    this.setLoading(false)
                    this.list = res.data.content
                    if (params.page === 1) {
                        this.total = res.data.pageinfo.rowCount
                    }
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 编辑优惠券
        editCoupon(item) {
            this.$router.push({
                name: 'CouponEdit',
                query: {
                    couponvoucherid: item.couponvoucherid
                }
            })
        },
        // 停止优惠券
        stopCoupon(item) {
            this.$confirm('停止后不可恢复，是否确定停止该优惠券？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                cancelCouponVoucher({
                    data: {innerid: item.couponvoucherid},
                    success: res => {
                        this.setLoading(false)
                        item.status = 9
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
                // 取消删除
            })
        },
        // 查看优惠券
        checkCoupon(item) {
            this.$router.push({
                name: 'CouponEdit',
                query: {
                    couponvoucherid: item.couponvoucherid
                }
            })
        },
        // 复制优惠券
        copyCoupon(item) {
            this.$router.push({
                name: 'CouponEdit',
                query: {
                    couponvoucherid: item.couponvoucherid,
                    iscopy: 1
                }
            })
        },
        // 统计优惠券
        statisticsCoupon(item) {
            this.$router.push({
                name: 'CouponStatistics',
                query: {
                    couponvoucherid: item.couponvoucherid
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .couponList {
        .search_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            .left {
                .el-button {
                    width: 120px;
                    height: 36px;
                }
            }
            .right {
                .el-input {
                    width: 330px;
                    height: 36px;
                    margin-right: 30px;
                }
                .el-button {
                    width: 96px;
                    height: 36px;
                }
            }
        }
        .el-table {
            .center {
                text-align: center;
            }
            .right {
                text-align: right;
            }
            .btn {
                span {
                    color: #409EFF;
                }
                .handle {
                    cursor: pointer;
                }
            }
        }
    }
</style>